import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './images/liltepng/img_title.png';
import _imports_1 from './images/weather/weath.png';
import _imports_2 from './images/weather/qing-weather.png';
import _imports_3 from './images/weather/yin-weather.png';
import _imports_4 from './images/liltepng/backBtn.png';
import _imports_5 from './images/liltepng/img_di.png';
var _withScopeId = function (n) {
  return _pushScopeId("data-v-103198a8"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "backdrop"
};
var _hoisted_2 = {
  class: "header",
  style: {}
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    src: _imports_0,
    style: {
      "width": "100%"
    }
  }, null, -1);
});
var _hoisted_4 = {
  class: "d-flex align-items-center pl-32 pt-2 position-absolute",
  style: {
    "top": "0"
  }
};
var _hoisted_5 = {
  style: {
    "font-size": "20px"
  }
};
var _hoisted_6 = {
  key: 0,
  src: _imports_1,
  style: {
    "width": "60px",
    "height": "60px"
  }
};
var _hoisted_7 = {
  key: 1,
  src: _imports_2
};
var _hoisted_8 = {
  key: 2,
  src: _imports_3
};
var _hoisted_9 = {
  class: "mr-2",
  style: {
    "font-size": "20px"
  }
};
var _hoisted_10 = {
  style: {
    "font-size": "20px"
  }
};
var _hoisted_11 = {
  style: {
    "top": "10px",
    "right": "80px"
  },
  class: "d-flex align-items-center position-absolute"
};
var _hoisted_12 = {
  class: "d-flex align-items-center ml-4"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", null, "报警通知", -1);
});
var _hoisted_14 = {
  style: {
    "width": "115px"
  },
  class: "ml-4"
};
var _hoisted_15 = {
  class: "text-glow fs-24 fw-7",
  style: {
    "letter-spacing": "0.25em"
  }
};
var _hoisted_16 = {
  class: "fs-12 d-flex-between-center",
  style: {
    "width": "115px"
  }
};
var _hoisted_17 = {
  class: "footer"
};
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("img", {
    src: _imports_5
  }, null, -1);
});
var _hoisted_19 = {
  style: {
    "position": "absolute",
    "width": "500px"
  },
  class: "d-flex justify-content-between text-center"
};
import { computed, onMounted, onUnmounted, ref } from "vue";
import AMapLoader from "@amap/amap-jsapi-loader";
import ScreenFull from "@/components/ScreenFull.vue";
import moment from "moment";
import { DateFormat } from "../../utils/moment";
import { useRoute, useRouter } from "vue-router";
import YkAdaptiveBox from "@/components/adaptive-box/YkAdaptiveBox.vue";
import { Bell, MuteNotification } from "@element-plus/icons-vue";
import settings from "@/settings";
import { ElNotification } from "element-plus";
import { useStore } from "vuex";
import { storage } from "@utils/storage";
import { defaultPath } from "@typings/menuList";
export default /*#__PURE__*/_defineComponent({
  __name: 'largeScreen',
  setup: function (__props) {
    onMounted(function () {
      soundStatus.value = storage.local.get('soundStatue') || false;
      showCityInfo();
      nowTime();
      ssu = new SpeechSynthesisUtterance();
      ssu.voice = window.speechSynthesis.getVoices().filter(function (voice) {
        return voice.localService === true && voice.lang === 'zh-CN';
      })[0];
      ssu.lang = 'zh-ch';
      ssu.rate = 1;
      loadWebSocket();
    });
    // region TODO 顶部标题栏
    //获取天气
    var AaMap = null;
    var weatherInfo = ref({});
    function showCityInfo() {
      //加载天气查询插件
      AMapLoader.load({
        key: '6d2f7f9db35d495cfff3e9e3cd4a982a',
        version: '2.0',
        // version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Weather'] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then(function (aMap) {
        AaMap = aMap;
        var weather = new AaMap.Weather();
        weather.getLive('韶关', function (err, data) {
          if (err) {
            return;
          }
          weatherInfo.value = data;
          console.log(data);
        });
      });
    }
    // 当前时间
    var datetime = ref({});
    var timer = null;
    var nowTime = function () {
      timer = setInterval(function () {
        datetime.value = {
          date: moment().format(DateFormat.date),
          time: moment().format(DateFormat.time),
          week: moment().format('dddd')
        };
      }, 500);
    };
    function logOut() {
      router.replace(defaultPath.value);
    }
    var route = useRoute();
    var isActive = computed(function () {
      return route.name == 'data';
    });
    var isDevice = computed(function () {
      return route.name == 'device';
    });
    var isYunwei = computed(function () {
      return route.name == 'operationAndMaintenance';
    });
    // endregion
    var soundStatus = ref(false);
    function turnOffSound() {
      soundStatus.value = false;
      storage.local.set('soundStatue', false);
    }
    function openSound() {
      soundStatus.value = true;
      storage.local.set('soundStatue', true);
    }
    var store = useStore();
    var router = useRouter();
    var userInfo = computed(function () {
      return store.getters['app/userInfo'];
    });
    var wsUrl = ref("".concat(settings.WEBSOCKET, "/").concat(userInfo.value.id));
    var ws = null;
    function loadWebSocket() {
      ws && ws.close();
      ws = new WebSocket(wsUrl.value);
      ws.onopen = function () {
        console.log('连接成功 webSocket');
        ws.send('给我消息');
      };
      ws.onmessage = function (e) {
        console.log(e);
        var abc = e.data;
        var aaa = JSON.parse(abc);
        console.log(aaa);
        if (aaa.alarmLevel && soundStatus.value) {
          ElNotification({
            type: 'warning',
            title: "".concat(aaa.alarmLevel),
            zIndex: 999,
            showClose: true,
            duration: 5000,
            message: "".concat(aaa.alarmMessage)
          });
          var alarmData = "".concat(aaa.alarmLevel, " , ").concat(aaa.alarmMessage);
          voiceBroadcast(alarmData);
        } else if (aaa.alarmLevel) {
          ElNotification({
            type: 'warning',
            title: "".concat(aaa.alarmLevel),
            zIndex: 999,
            showClose: true,
            duration: 5000,
            message: "".concat(aaa.alarmMessage)
          });
        }
      };
    }
    var ssu;
    function voiceBroadcast(e) {
      ssu.text = e;
      speechSynthesis.speak(ssu);
    }
    onUnmounted(function () {
      ws.close();
    });
    return function (_ctx, _cache) {
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(YkAdaptiveBox, {
        mode: "full-height",
        "min-width": 1366
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(weatherInfo.value.city), 1), weatherInfo.value.weather === '多云' ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true), weatherInfo.value.weather === '晴' ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : _createCommentVNode("", true), weatherInfo.value.weather === '阴' ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, _toDisplayString(weatherInfo.value.weather), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(weatherInfo.value.temperature) + "°", 1)]), _createElementVNode("div", _hoisted_11, [_unref(defaultPath).value ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _imports_4,
            onClick: logOut
          })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [soundStatus.value ? (_openBlock(), _createBlock(_component_el_icon, {
            key: 0,
            size: "20",
            onClick: turnOffSound
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(Bell))];
            }),
            _: 1
          })) : (_openBlock(), _createBlock(_component_el_icon, {
            key: 1,
            size: "20",
            onClick: openSound
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(MuteNotification))];
            }),
            _: 1
          })), _hoisted_13]), _createVNode(ScreenFull, {
            class: "ml-4"
          }), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(datetime.value.time), 1), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, _toDisplayString(datetime.value.date), 1), _createElementVNode("div", null, _toDisplayString(datetime.value.week), 1)])])])]), _createVNode(_component_router_view, {
            class: "layout_view"
          }), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _unref(router).push('device');
            }),
            class: "mr-2",
            style: _normalizeStyle([{
              "font-size": "20px",
              "width": "170px",
              "height": "40px",
              "line-height": "40px",
              "cursor": "pointer"
            }, {
              background: _unref(isDevice) ? 'linear-gradient(180deg, rgba(34,107,234,0.00) 0%, rgba(34,107,234,0.77) 100%)' : ''
            }])
          }, "设备中心", 4), _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return _unref(router).push('data');
            }),
            class: "mr-2",
            style: _normalizeStyle([{
              "font-size": "20px",
              "width": "170px",
              "height": "40px",
              "line-height": "40px",
              "cursor": "pointer"
            }, {
              background: _unref(isActive) ? 'linear-gradient(180deg, rgba(34,107,234,0.00) 0%, rgba(34,107,234,0.77) 100%)' : ''
            }])
          }, "数据中心", 4), _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return _unref(router).push('operationAndMaintenance');
            }),
            style: _normalizeStyle([{
              "font-size": "20px",
              "width": "170px",
              "height": "40px",
              "line-height": "40px",
              "cursor": "pointer"
            }, {
              background: _unref(isYunwei) ? 'linear-gradient(180deg, rgba(34,107,234,0.00) 0%, rgba(34,107,234,0.77) 100%)' : ''
            }])
          }, "运维中心", 4)])])])];
        }),
        _: 1
      });
    };
  }
});